<template>
  <section id="products__product-display-section">
    <div class="products__main-title">
      <h2>Products</h2>
    </div>
    <div class="products__product-wrap">
      <system
        v-for="system in systems"
        :key="system.ID"
        :system="system" />
    </div>
  </section>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import System from '~/components/System'

export default {
  components: {
    System
  },
  head () {
    return {
      title: this.page.custom_fields ? this.page.custom_fields.page_title : '',
      meta: [
        { hid: 'description', name: 'description', content: this.page.custom_fields ? this.page.custom_fields.meta_description : '' }
      ]
    }
  },
  async asyncData (context) {
    const pageExists = context.store.getters['pages/doesPageExist']('home')
    if (pageExists) {
      const pageId = context.store.getters['pages/pageIdFromSlug']('home')
      let { data } = await context.$axios.get(`/api/pages/${pageId}`).catch((err) => {
        console.log(err)
      })
      if (data) {
        return {
          page: data,
          displayModal: false
        }
      }
    } else {
      // If no page exists set the ID to false
      return {
        page: {
          ID: false,
          displayModal: false
        }
      }
    }
  },
  computed: {
    ...mapGetters('products', {
      systems: 'systems'
    })
  },
  methods: {
    ...mapMutations({
      increment: 'increment'
    })
  }
}
</script>

<style lang="scss" scoped>

.woocommerce-variation-add-to-cart {
  @media screen and (max-width: 650px) {
    text-align: center;
  }
}

.generic-category-title {
  padding-bottom: 15px;
  border-bottom: 1px solid $grey;
  margin-bottom: 45px;
}

.products {

  @include e('product-wrap') {
    width: 100%;
    max-width: 1110px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;

    @media screen and (max-width: 800px) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
  }
}

#products__product-display-section {
  padding: 60px 45px;

  .vertical-divider {
    width: 1px;
    background-color: $grey;
    height: 100%;
    margin: 0 auto;
    position: absolute;
    left: 50%;

    @media screen and (max-width: 650px) {
      display: none;
    }
  }

  @media screen and (max-width: 650px) {
    padding: 30px 15px;
  }

  @media screen and (max-width: 460px) {
    padding-bottom: 0;
  }
}

#products__information--nav {
  width: 100%;
  margin: 0 auto;
  padding: 0 10%;
  background-color: $aqua-blue;
  color: #fff;

  .products__nav--container {

    ul {
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        display: inline-block;
        height: 100%;
        padding: 22.5px 40px;
        font-size: 1.2em;
        font-weight: bold;

        a {
          color: #fff;
          cursor: pointer;
          font-size: 16px;
        }

        @media (min-width: 650px) and (max-width: 850px) {
          padding: 20px 40px;
        }

        @media screen and (max-width: 649px) {
          padding: 20px 8px;
        }

        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          padding-right: 0;
        }
      }

      @media screen and (max-width: 850px) {
        text-align: center;
      }
    }
  }
}

.products__information--features {
  @include section__container;
  border-bottom: 1px solid $grey;

  .features__section--item {
    text-align: center;
  }

  .features__item--icon {
    display: inline-block;
    max-width: 27%;
    text-align: center;
    vertical-align: top;
    margin-right: 35px;

    img {
      max-width: 70px;
    }

    @media screen and (max-width: 411px) {
      margin-right: 8%;
    }
  }

  .features__item--content {
    display: inline-block;
    max-width: 67%;
    vertical-align: top;
    font-size: 18px;
    text-align: left;

    h2 {
      margin: 13px 0 0 0;
      font-size: 36px;

      @media screen and (max-width: 850px) {
        margin: 0;
        font-size: 1.8em;
      }
    }
  }
}

.features__section--hero {
  min-height: 485px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left bottom;

  @media screen and (max-width: 580px) {
    min-height: 220px;
  }
}

.features__tilt-sensor--section {
  @include section__container;
  padding: 240px 10%;
  border-bottom: 1px solid #d7d7d7;
  background-size: 38%;
  background-repeat: no-repeat;
  background-position: 87% center;

  .tilt-sensor-content-container {
    max-width: 400px;
    margin: auto;

    @media (min-width: 651px) and (max-width: 850px) {
      width: 44%;
    }

    @media screen and (max-width: 650px) {
      float: none;
    }
  }

  .tilt-sensor-image-mobile {
    display: none;
  }

  @media screen and (min-width: 1200px) {
    background-size: 450px;
  }

  @media screen and (max-width: 850px) {
    padding: 120px 5%;
  }

  @media screen and (max-width: 650px) {
    text-align: center;
    background-image: none !important;
    padding: 60px 5%;

    .tilt-sensor-image-mobile {
      max-width: 285px;
      margin: auto;
      margin-bottom: 25px;
      display: block;
    }
  }
}

.features__anti-deadlock--section {
  @include section__container;
  padding: 240px 10%;
  border-bottom: 1px solid $grey;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 20% 0;
  overflow: hidden;

  .anti-deadlock--mobile-image {
    display: none;

    @media screen and (max-width: 650px) {
      display: inline-block;
    }
  }

  .offset-by-six {

    @media screen and (max-width: 850px) {
      width: 50%;
      float: right;
    }

    @media screen and (max-width: 650px) {
      width: 100%;
      float: none;
    }
  }

  @media screen and (max-width: 850px) {
    padding: 120px 10%;

    .anti-deadlock--mobile-image {
      margin: 2.5em 0 4em;
      position: relative;
      left: -16%;
      width: 132%;
      overflow: hidden;
    }
  }

  @media screen and (max-width: 650px) {
    background-image: none !important;
    text-align: center;
  }

  @media screen and (max-width: 459px) {
    .anti-deadlock--mobile-image {
      position: relative;
      left: -21.4%;
      width: 143%;
    }
  }
}

#products__information--specs {
  @include section__container;

  h3 {
    font-size: 36px;
    margin: 0 0 35px 0;
    font-weight: normal;

    @media screen and (max-width: 850px) {
      margin: 0 0 15px 0;
    }
  }

  .spec-row {
    margin-bottom: 50px;

    &:last-child {
      margin-bottom: 0;
    }

    @media screen and (max-width: 850px) {
      margin-bottom: 0;
    }
  }

  .spec-item {
    h4 {
      text-transform: uppercase;
      font-weight: bold;
      padding: 0 0 10px 0;
      margin: 25px 0 10px 0;
      border-bottom: 1px solid $grey;
    }

    span {
      font-size: 1.25em;
    }

    @media screen and (max-width: 850px) {
      margin-bottom: 15px;
    }
  }

}

.product-type-variable, .product-type-simple {
  padding: 45px 8.5%;

  select {
    padding: 7px 14px;
    height: 40px;
    border: none;
    width: 100%;
    box-shadow: none;
    font-weight: 700;
    background-color: transparent;
    background-image: none;
    margin: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
}

.products {

  @include e('product-display-section') {
    padding: 57px 7%;
  }

  @include e('main-title') {
    max-width: 1110px;
    margin: 0 auto 0px;
    padding: 0px 15px 0px;

    h2 {
      font-size: 45px;
      margin: 0px 0px 15px;
      padding-bottom: 15px;
      line-height: 1em;
      border-bottom: solid 1px #CCC;

      @media screen and (max-width:800px) {
        font-size: 35px;
      }
    }

    @include m('accessories') {
      margin-top: 75px;
      margin: 75px auto 7px;
    }
  }

  @include e('title') {
    font-size: 28px;
    margin: 15px 0 10px;
    padding-bottom: 10px;
  }

  @include e('accessories-container-empty') {
    width: 80%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>
